import { Component, OnInit } from '@angular/core';
import { Overlay, overlayConfigFactory } from 'angular2-modal';
import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { DialogRef, ModalComponent, CloseGuard } from 'angular2-modal';
import { Router, ActivatedRoute, NavigationStart, NavigationEnd } from '@angular/router';
export class CustomModalContext extends BSModalContext {
  public modalData: any;
}
@Component({
  selector: 'app-do-not-refresh-and-back',
  templateUrl: './do-not-refresh-and-back.component.html',
  styleUrls: ['./do-not-refresh-and-back.component.css'],
  providers: [Modal]
})
export class DoNotRefreshAndBackComponent implements OnInit, ModalComponent<CustomModalContext> {
  context: CustomModalContext;
  modalData: any;
  constructor(public dialog: DialogRef<CustomModalContext>, private modal: Modal, private router: Router) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.dialog.close();
      }
    });
  }

  ngOnInit() {
    this.modalData = this.dialog.context.modalData;
    this.modalData.Action = this.modalData.Action == undefined ? 'Continue' : this.modalData.Action;
  }
  continueClick() {
    this.dialog.context.modalData.isShowDoNotRefreshAndBack = this.modalData.flag == undefined ? false : this.modalData.flag;
    this.dialog.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/_directive/do-not-refresh-and-back/do-not-refresh-and-back.component.ts